import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DxButtonModule } from "devextreme-angular";
import { RouterModule } from "@angular/router";
import { AppGlobals } from "src/app/app.globals";
import { FeatureFlags } from "src/app/interfaces/enums/feature-flag";
import { LogoConfigComponent } from "./logo-config/logo-config.page";
import { SharepointConfigComponent } from "src/app/pages/config/sharepoint-config/sharepoint-config.component";

@Component({
    selector: "general",
    imports: [CommonModule, DxButtonModule, RouterModule, LogoConfigComponent, SharepointConfigComponent],
    templateUrl: "./general.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./general.page.css"]
})
export class GeneralComponent implements OnInit {
  sandboxEnabled = AppGlobals.UserCan(FeatureFlags.Sandbox);

  constructor(private appGlobals: AppGlobals) {}

  ngOnInit(): void {
    this.appGlobals.$headerTitle.next(
      $localize`:@@configuration:Configuration`,
    );
  }
}
